import { graphql } from "@opensea/graphql"
import { RarityBadgeFragment } from "../../../../../components/RarityBadge/RarityBadge.fragment"

export const CreateOfferFlowTableRowFragment = graphql(
  `
    fragment CreateOfferFlowTableRow on Item {
      id
      tokenId
      name
      imageUrl
      isFungible
      chain {
        identifier
        offerCurrency {
          symbol
        }
      }
      lastSale {
        token {
          unit
          symbol
        }
      }
      bestOffer {
        id
        pricePerItem {
          token {
            unit
            symbol
          }
        }
      }
      bestListing {
        id
        pricePerItem {
          token {
            unit
            symbol
          }
        }
      }
      collection {
        id
        floorPrice {
          id
          pricePerItem {
            token {
              unit
              symbol
            }
          }
        }
        fees {
          openseaFee {
            feeBasisPoints
          }
          totalCreatorFee {
            feeBasisPoints
          }
        }
      }
      ...RarityBadge
    }
  `,
  [RarityBadgeFragment],
)
